import React from 'react';
// import Navbar               from '../components/Navbar';
import HeroSection          from '../components/HeroSection';
import AboutSection         from '../components/AboutSection';
import ServicesSection      from '../components/ServicesSection';
import ProcessSection       from '../components/ProcessSection';
import TechSection          from '../components/TechSection';
import IntelligenceSection  from '../components/IntelligenceSection';
import AIPlatformSection    from '../components/AIPlatformSection';
import FAQSection           from '../components/FAQSection';
import CareersSection       from '../components/CareersSection';
import ProjectsSection      from '../components/ProjectsSection';
import ClientsSection       from '../components/ClientsSection';
import TeamSection          from '../components/TeamSection';
import TestimonialsSection  from '../components/TestimonialsSection';
import QuotationSection     from '../components/QuotationSection';
import ContactSection       from '../components/ContactSection';
import FollowUsSection      from '../components/FollowUsSection';
// import Footer               from '../components/Footer';
import SocialMediaPackages from '../components/SocialMediaPackages';
import FacebookFeed from '../components/FacebookFeed';

export default function Home() {
  return (
    <>
      {/* <Navbar /> */}
      <HeroSection />
      <ServicesSection />
      <ProcessSection />
      <TechSection />
      <ProjectsSection />
      

      <SocialMediaPackages />
      <TestimonialsSection />
      <AboutSection />
      
      
      
      
      <IntelligenceSection />
      {/* <AIPlatformSection /> */}
      <FAQSection />
      <CareersSection />
      
      <ClientsSection />
      {/* <TeamSection /> */}
      
      {/* <QuotationSection /> */}
      {/* <ContactSection /> */}
      
      <FollowUsSection />
      {/* <Footer /> */}
    </>
  );
}
